const TONE = {
  amber: "text-red-500",
  green: "text-emerald-400",
  blue: "text-blue-400",
  violet: "text-violet-400",
  white: "text-[#0F172A]",
};

export const StatCard = ({ label, value, sub, icon: Icon, tone = "white", testId, delay = 0 }) => (
  <div
    data-testid={testId}
    style={{ animationDelay: `${delay}ms` }}
    className="animate-fade-up border border-[#E2E5EA] bg-[#FFFFFF] p-5 transition-colors duration-200 hover:border-[#C7CDD6]"
  >
    <div className="flex items-start justify-between">
      <p className="text-xs uppercase tracking-wider text-[#6B7280]">{label}</p>
      {Icon && <Icon size={18} className={TONE[tone]} weight="bold" />}
    </div>
    <p className={`mt-3 font-heading text-2xl font-bold tabular-nums tracking-tight ${TONE[tone]}`}>
      {value}
    </p>
    {sub && <p className="mt-1 text-xs text-[#9CA3AF]">{sub}</p>}
  </div>
);
